// import { CONSTANTS } from "config/constant";
// import React from "react";
// import { useTranslation } from "react-i18next";
// const ViewLaundryMan = ({ data }) => {
//   const { t } = useTranslation();
//   console.log("data ==>", data);
//   return (
//     <>
//       <div style={styles.container}>
//         {/* <h2 style={styles.title}>{data?.store_name}</h2> */}
//         <table style={styles.table}>
//           <tbody>
//             <tr>
//               <td>{t("Title")}</td>
//               <td>{t("Details")}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Profile Pic")}:</td>
//               <td>
//                 {
//                   <img
//                     src={
//                       CONSTANTS?.BACKEND_URL +
//                       data?.profile_image?.[0]?.file_url
//                     }
//                     // style={{ maxHeight: "4rem", width: "4rem",height:"auto" ,borderRadius:"1rem"}}
//                     style={{
//                       width: "4rem",
//                       height: "4rem",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 }
//               </td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Name")}:</td>
//               <td>{data?.first_name + " " + data?.last_name}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Email")}:</td>
//               <td>
//                 <td>{data?.email}</td>
//               </td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Password")}:</td>
//               <td>{data?.unhashed_password}</td>
//             </tr>

//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Phone number")}:</td>
//               <td>{data?.phone_no}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Provider")}:</td>
//               <td>{data?.provider}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("CNIC Front Image")}:</td>
//               <td>
//                 {
//                   <img
//                     src={
//                       CONSTANTS?.BACKEND_URL +
//                       data?.cnic_front_image?.[0]?.file_url
//                     }
//                     style={{
//                       width: "4rem",
//                       height: "4rem",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 }
//               </td>
//             </tr>

//             <tr>
//               <td style={styles.label}>{t("CNIC Back Image")}:</td>
//               <td>
//                 {
//                   <img
//                     src={
//                       CONSTANTS?.BACKEND_URL +
//                       data?.cnic_back_image?.[0]?.file_url
//                     }
//                     style={{
//                       width: "4rem",
//                       height: "4rem",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 }
//               </td>{" "}
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Licence Front Image")}:</td>
//               <td>
//                 {
//                   <img
//                     src={
//                       CONSTANTS?.BACKEND_URL +
//                       data?.license_front_image?.[0]?.file_url
//                     }
//                     style={{
//                       width: "4rem",
//                       height: "4rem",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 }
//               </td>{" "}
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Licence Back Image")}:</td>
//               <td>
//                 {
//                   <img
//                     src={
//                       CONSTANTS?.BACKEND_URL +
//                       data?.license_back_image?.[0]?.file_url
//                     }
//                     style={{
//                       width: "4rem",
//                       height: "4rem",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 }
//               </td>{" "}
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Vehicle Number")}:</td>
//               <td>{data?.vehicle_number}</td>
//             </tr>

//             <tr>
//               <td style={styles.label}>{t("Vehicle Type")}:</td>
//               <td>{data?.vehicle_type}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Pickup Order Rate")}:</td>
//               <td>{data?.pickup_order_rate}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Delivery Order Rate")}:</td>
//               <td>{data?.role}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Dispatch Order Rate")}:</td>
//               <td>{data?.dispatch_order_rate}</td>
//             </tr>
//             <tr>
//               <td style={styles.label}>{t("Availability")}:</td>
//               <td>{data?.availability?.[0]?.day}</td>
//             </tr>
//             <tr style={{ background: "#e5e2e2" }}>
//               <td style={styles.label}>{t("Driving License Number")}:</td>
//               <td>{data?.driving_license_number}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };
// const styles = {
//   container: {
//     maxWidth: "50rem",
//     minWidth: "50rem",
//     margin: "auto",
//     padding: "20px",
//     // backgroundColor: "#f0f0f0",
//     borderRadius: "8px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   },
//   title: {
//     textAlign: "center",
//     color: "#333",
//     marginBottom: "20px",
//   },
//   table: {
//     width: "100%",
//   },
//   label: {
//     fontWeight: "600",
//     paddingRight: "10px",
//     verticalAlign: "top",
//     padding: "1rem",
//   },
//   select: {
//     width: "100%",
//     padding: "8px",
//     borderRadius: "4px",
//     border: "1px solid #ccc",
//     fontSize: "14px",
//     marginTop: "5px",
//   },
// };

// export default ViewLaundryMan;

import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { Button, Image, Table, Tag } from "antd";
import moment from "moment";
import { EyeOutlined } from "@ant-design/icons";
import DriverOrder from "components/Tables/Orders/DriverOrder";
import TransectionsDriver from "components/Tables/LaundryMan/TransectionsDriver";

const ViewStore = () => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state && location.state.data;
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }
  const datass = [
    {
      key: "1",
      id: "IM1093",
      orderDate: "Apr 03, 2024 03:06 pm",
      pickupDate: "Oct 01, 2023 10 - 11:59",
      deliveryStatus: "Aug 09, 2023 16 - 17:59",
      orderStatus: "Order confirmed",
      amount: 413.43,
      assign: "Delivery",
      accepted: "Accepted",
    },
    {
      key: "2",
      id: "IM5091",
      orderDate: "Apr 03, 2024 03:06 pm",
      pickupDate: "Feb 06, 2023 20 - 21:59",
      deliveryStatus: "May 11, 2023 18 - 19:59",
      orderStatus: "Processing",
      amount: 275.63,
      assign: "Delivery",
      accepted: "Pending",
    },
    {
      key: "3",
      id: "LM000091",
      orderDate: "May 20, 2024 06:10 pm",
      pickupDate: "May 20, 2024 10 - 11:59",
      deliveryStatus: "May 30, 2024 12 - 13:59",
      orderStatus: "Order confirmed",
      amount: 235.29,
      assign: "Pick-Up",
      accepted: "Pending",
    },
  ];
  const columns = [
    {
      title: "ID",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Order Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (timestamp) =>
        moment.unix(timestamp).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Pickup Date",
      dataIndex: "order_pickup_time",
      key: "order_pickup_time",
      render: (timestamp) =>
        moment.unix(timestamp).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Delivery Date",
      dataIndex: "order_delivery_time",
      key: "order_delivery_time",
      render: (timestamp) =>
        moment.unix(timestamp).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Order Status",
      dataIndex: "order_status",
      key: "order_status",
    },
    {
      title: "Pending Amount",
      dataIndex: "pending_amount",
      key: "pending_amount",
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
    },
    {
      title: "Order Type",
      dataIndex: "order_type",
      key: "order_type",
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      key: "payment_type",
    },
    // {
    //   title: "Assign",
    //   dataIndex: "assign",
    //   key: "assign",
    // },
    {
      title: "Accepted",
      dataIndex: "status",
      key: "status",
      render: (accepted) => {
        let color = accepted === "order_placed" ? "yellow" : "green";
        return (
          <Tag color={color}>
            {accepted === "order_placed" ? "Pending" : "Accepted"}
          </Tag>
        );
      },
    },

    {
      title: t("Actions"),
      key: "actions",
      render: (text, record) => {
        return (
          <div>
            <Button
              type="default"
              icon={<EyeOutlined />}
              onClick={() => handleView(record)}
              style={{ marginLeft: "5px" }}
            ></Button>
          </div>
        );
      },
    },
  ];

  const handleView = (record) => {
    navigate(`/admin/order-management/${record._id}`, {
      state: { data: record },
    });
  };
  console.log(data, "driverDtaa");
  return (
    <>
      <div className="relative flex gap-8">
        <div style={styles.container} className="min-h-[37rem]">
          <table style={styles.table}>
            <tbody>
              <div
                className="flex cursor-pointer items-center gap-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <MdOutlineArrowBack
                  className="cursor-pointer"
                  style={{ fontSize: "17px" }}
                />
                <p>{t("Back")}</p>
              </div>
              <p className="mb-4 text-center text-[20px] font-semibold">
                {t("View Driver")}
              </p>
              <hr className="mb-4" />
              <div className="mb-3 flex justify-around">
                <tr className="flex w-full flex-col">
                  <td className="flex w-full items-center justify-center">
                    <div
                      style={{
                        width: "8rem",
                        height: "8rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                      className="flex items-center justify-center"
                    >
                      <Image
                        width={200}
                        src={
                          CONSTANTS?.IMG_DIRECTORY +
                          data?.profile_image?.[0]?.file_url
                        }
                        style={{
                          width: "8rem",
                          height: "8rem",
                          borderRadius: "50%",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      />
                    </div>
                  </td>
                </tr>
                {/* <tr className="flex flex-col">
                  <td className="w-[12rem]"></td>
                  <td className="w-[12rem]"></td>
                </tr>
                <tr className="flex flex-col">
                  <td className="w-[12rem]"></td>
                  <td className="w-[12rem]"></td>
                </tr> */}
              </div>
              <div className="mb-3 flex justify-around">
                {/* Name */}
                <tr className="flex flex-col">
                  <td
                    style={styles.label}
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                  >
                    {t("Name")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.first_name + " " + data?.last_name}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Email")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.email}
                  </td>
                </tr>
                {/* Email */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Driving License Number")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.driving_license_number}
                  </td>
                </tr>
                {/* Email */}
              </div>
              <div className="mb-3 flex justify-around">
                {/* <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Password")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    <div className="flex justify-between">
                      <div>
                        {showPassword
                          ? data?.unhashed_password
                          : "*".repeat(data?.unhashed_password?.length)}
                      </div>
                      <div
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </div>
                    </div>
                  </td>
                </tr> */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {/* {t("Pick up order rate from laundrybox")} */}
                    {t("Driver type")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.laundry_man_type == "truck_driver"
                      ? "Truck Driver"
                      : "Car"}
                  </td>
                </tr>

                {/* Phone number */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Phone number")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.phone_no}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Provider")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.provider_info?.store_name}
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("CNIC Front Image")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    <div
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    >
                      <Image
                        src={
                          CONSTANTS?.IMG_DIRECTORY +
                          data?.cnic_front_image?.[0]?.file_url
                        }
                        style={{
                          width: "4rem",
                          height: "4rem",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </td>
                </tr>

                {/* CNIC Back Image */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("CNIC Back Image")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    <div
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    >
                      <Image
                        src={
                          CONSTANTS?.IMG_DIRECTORY +
                          data?.cnic_back_image?.[0]?.file_url
                        }
                        style={{
                          width: "4rem",
                          height: "4rem",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </td>
                </tr>

                {/* Licence Front Image */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Licence Front Image")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    <div
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    >
                      <Image
                        src={
                          CONSTANTS?.IMG_DIRECTORY +
                          data?.license_front_image?.[0]?.file_url
                        }
                        style={{
                          width: "4rem",
                          height: "4rem",
                          borderRadius: "50%",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      />
                    </div>
                    {/* <img
                      src={
                        CONSTANTS?.BACKEND_URL +
                        data?.license_front_image?.[0]?.file_url
                      }
                      alt=""
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    /> */}
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                {/* Licence Back Image */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Licence Back Image")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    <div
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "50%",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    >
                      <Image
                        src={
                          CONSTANTS?.IMG_DIRECTORY +
                          data?.license_back_image?.[0]?.file_url
                        }
                        style={{
                          width: "4rem",
                          height: "4rem",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </td>
                </tr>

                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Vehicle Number")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.vehicle_number}
                  </td>
                </tr>

                {/* Vehicle Type */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Vehicle Type")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.vehicle_type}
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                {/* Pickup Order Rate */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Pickup Order Rate")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.pickup_order_rate}
                  </td>
                </tr>

                {/* Delivery Order Rate */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Delivery Order Rate")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.delivery_order_rate}
                  </td>
                </tr>

                {/* Dispatch Order Rate */}
                {/* <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Dispatch Order Rate")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.dispatch_order_rate}
                    
                  </td>
                </tr> */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {data?.laundry_man_type == "truck_driver"
                      ? t("Pick up order rate from laundry to store")
                      : t("Pick up order rate from laundrybox")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.laundry_man_type == "truck_driver"
                      ? data?.pickup_order_rate_from_laundry_to_store
                      : data?.pickup_order_rate_from_laundrybox}{" "}
                  </td>
                </tr>

                {/* <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {data?.laundry_man_type == "truck_driver"
                      ? t("Pick up order rate from laundrybox")
                      : ""}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.laundry_man_type == "truck_driver"
                      ? data?.pickup_order_rate_from_laundrybox
                      : ""}
                  </td>
                </tr> */}
              </div>

              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {data?.laundry_man_type == "truck_driver"
                      ? t("Pick up order rate from laundrybox")
                      : ""}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.laundry_man_type == "truck_driver"
                      ? data?.pickup_order_rate_from_laundrybox
                      : ""}{" "}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {data?.laundry_man_type == "truck_driver"
                      ? t("Pick up order rate from store to laundry")
                      : ""}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.laundry_man_type == "truck_driver"
                      ? data?.pickup_order_rate_from_store_to_laundry
                      : ""}{" "}
                  </td>
                </tr>

                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Availability")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.availability?.map((day) => {
                      return (
                        <div>
                          <p> {day?.day}</p>
                          <p style={{ fontSize: "13px" }}>
                            {" Start Time: " +
                              moment
                                .unix(day?.start_time)
                                .format("YYYY-MM-DD HH:mm")}
                          </p>
                          <p style={{ fontSize: "13px" }}>
                            {" End Time: " +
                              moment
                                .unix(day?.end_time)
                                .format("YYYY-MM-DD HH:mm")}
                          </p>
                          <hr className="mb-2" />
                        </div>
                      );
                    })}
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                {/* Availability */}
                {/* <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Availability")}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] ">
                    {data?.availability?.map((day) => {
                      return (
                        <div>
                          <p> {day?.day}</p>
                          <p style={{ fontSize: "13px" }}>
                            {" Start Time: " +
                              moment
                                .unix(day?.start_time)
                                .format("YYYY-MM-DD HH:mm")}
                          </p>
                          <p style={{ fontSize: "13px" }}>
                            {" End Time: " +
                              moment
                                .unix(day?.end_time)
                                .format("YYYY-MM-DD HH:mm")}
                          </p>
                          <hr className="mb-2" />
                        </div>
                      );
                    })}
                  </td>
                </tr> */}

                {/* Driving License Number */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-light"
                    style={styles.label}
                  >
                    {/* {t("Driving License Number")} */}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] font-semibold">
                    {/* {data?.driving_license_number} */}
                  </td>
                </tr>

                {/* Driving License Number */}
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {/* {t("Driving License Number")} */}
                  </td>
                  <td className="font-lighht w-[12rem] pl-4 text-[14px] font-semibold"></td>
                </tr>
              </div>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mx-auto mt-3" style={{ width: "80%" }}>
        {/* <Table columns={columns} dataSource={data?.orders} pagination={false} /> */}
        <DriverOrder id={data?._id} />
      </div>
      <div className="mx-auto mt-3" style={{ width: "80%" }}>
        <TransectionsDriver id={data?._id} />
      </div>
    </>
  );
};
// className="flex flex-col"

const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    // paddingTop: "1rem",
    padding: "1rem",
  },
};

export default ViewStore;
